<template>
  <div class="text-center mt-8 w-100 justify-center d-flex">
    <div class="container-empty">
      <div>
        <div class="mb-4 mt-4">
          <font-awesome-icon class="download-icon" icon="fa-folder" />
        </div>
        <div class="text-subtitle-1 mb-2">
          {{ title }}
        </div>
        <div class="text-body-2 grey--text">
          {{ description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      default: 'Aun no existen carpetas en los documentos',
    },
    description: {
      type: String,
      default: 'Crea una carpeta para comenzar a organizar tus archivos.',
    },
  },
};
</script>
